import useSWRMutation from 'swr/mutation';
import capsFetcher from '../../shared/capsFetcher';

const fetcher = async (config, { arg: data }) => {
  const res = await capsFetcher({
    method: 'POST',
    url: '/recurring_payments',
    data,
  });
  return res.data;
};

const useCreateRecurringPayment = (options) => useSWRMutation(
  '/recurring_payments',
  fetcher,
  { ...options },
);

export default useCreateRecurringPayment;
